import React, { useContext } from "react";
import ContentLayout from '../../layout/ContentLayout/index.jsx'
import TopHeader from "../../components/topheader/Index.jsx";
import Footer from "../../components/footer/Index.jsx";
import "./index.css";
import OrderProduct from "../../components/OrderProduct/OrderProduct.js";
import { AppContext } from '../../context/context.js';

const WholeSaleBillingPage = () => {
  const { state} = useContext(AppContext);
  const { currentUser } = state;
  return (
    <>
      <ContentLayout>
        <div className="">
          <OrderProduct type="wholesale" currentUser={currentUser ? currentUser : null}></OrderProduct>
          <Footer />
        </div>
      </ContentLayout>
    </>
  );
};

export default WholeSaleBillingPage;
